<template>
  <div>
    <AppDataProperty
      contentId="appInfo"
      @dataAvailable="
        data => {
          appData = data?.metaData || {}
        }
      "
      isComponent
    />
    <AppDataProperty
      contentId="affiliationData"
      @dataAvailable="
        data => {
          affiliationData = data?.metaData || {}
        }
      "
      isComponent
    />
    <BottomSheetModal ref="modal" headerBg="#fff">
      <div class="px-6">
        <UserStats />
      </div>
      <AffiliationShareDetails
        :appData="{
          affiliationUrl: affiliationData?.url || '',
          affiliationDetailText: appData?.affiliationDetailText || '',
          affiliationCode: affiliationData?.code || '',
        }"
      />
    </BottomSheetModal>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import BottomSheetModal from '@/components/utils/BottomSheetModal.vue'
import AppDataProperty from '@/components/appData/AppDataProperty.vue'
import AffiliationShareDetails from './AffiliationShareDetails.vue'
import UserStats from './UserStats.vue'

export default defineComponent({
  name: 'TransactionDetailsComponent',
  components: {
    BottomSheetModal,
    AppDataProperty,
    UserStats,
    AffiliationShareDetails,
  },
  props: {},
  data() {
    return {
      reference: '',
      eventsIds: [],
      appData: {},
      affiliationData: {},
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'affiliation_withdraw_requested',
      this.hideAffiliationSharing,
    )
    const id3 = this.$Events.handleEvent(
      'affiliation_share_requested',
      this.showAffiliationSharing,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id3)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    hideAffiliationSharing() {
      this.$refs.modal.hide()
    },
    showAffiliationSharing() {
      this.$refs.modal.show()
    },
  },
})
</script>
